import React from "react";

const Footer = () => {
    return (
        <footer style={{ textAlign: "center", padding: "20px 0", background: "#f8f9fa", fontSize: "14px", color: "#6c757d" }}>
            <p>© 2025 Fuel Platform by Roadex.</p>
            {/* 
            <p>
                <a href="/privacy-policy" style={{ color: "#007bff", textDecoration: "none" }}>
                    Privacy Policy
                </a> 
                | 
                <a href="/terms" style={{ color: "#007bff", textDecoration: "none" }}>
                    Terms
                </a>
            </p>
            */}
        </footer>
    );
};

export default Footer;
